import React from 'react';
import { Alert, Box, Button, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

interface ServiceAreaStepProps {
  polygonCount: number;
  hubCount: number;
  requiresHubs: boolean;
  onDrawPolygon: () => void;
}

export default function ServiceAreaStep({
  polygonCount,
  hubCount,
  requiresHubs,
  onDrawPolygon,
}: ServiceAreaStepProps) {
  const { t } = useTranslation('onboarding');
  return (
    <Box sx={{ width: '100%' }}>
      <Typography variant="h4" sx={{ mb: 1.5 }}>
        {t('serviceArea.title')}
      </Typography>
      <Typography color="text.secondary" sx={{ mb: 3 }}>
        {t('serviceArea.description')}
      </Typography>
      {requiresHubs && polygonCount === 0 ? (
        <Alert severity="info" sx={{ mb: 2 }}>
          {t('serviceArea.hubInfo')}
        </Alert>
      ) : null}

      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2, gap: 2 }}>
        <Box sx={{ display: 'flex', gap: 1.5 }}>
          <Button
            variant="outlined"
            onClick={onDrawPolygon}
            data-testid="wizard.config.draw-polygon"
          >
            {requiresHubs ? t('serviceArea.drawZonesAndHubs') : t('serviceArea.drawZoneOnMap')}
          </Button>
        </Box>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          <Typography variant="body2" color={polygonCount > 0 ? 'text.primary' : 'text.secondary'}>
            {t('serviceArea.zonesCreated', { count: polygonCount })}
          </Typography>
          {requiresHubs ? (
            <Typography variant="body2" color={hubCount > 0 ? 'text.primary' : 'text.secondary'}>
              {t('serviceArea.hubsPlaced', { count: hubCount })}
            </Typography>
          ) : null}
        </Box>
      </Box>
    </Box>
  );
}
